import { FC, Suspense } from 'react';
import { PreloadedQuery } from 'react-relay';
import { ProgressStudentsGrowthAndEngagementQuery } from '../../../graphQLOperations/__generated__/ProgressStudentsGrowthAndEngagementQuery.graphql';
import { ThreeDotLoader } from '../../Fallback/ThreeDotsLoader';
import GrowthAndEngagementTable from './GrowthAndEngagementTable';

interface Props {
  growthQueryRef: PreloadedQuery<ProgressStudentsGrowthAndEngagementQuery> | unknown;
}

const ProgressStudentGrowthTable: FC<Props> = ({ growthQueryRef }) => {
  return (
    <>
      {growthQueryRef ? (
        <Suspense fallback={<ThreeDotLoader dark />}>
          <GrowthAndEngagementTable
            growthQueryRef={growthQueryRef as PreloadedQuery<ProgressStudentsGrowthAndEngagementQuery>}
          />
        </Suspense>
      ) : (
        <></>
      )}
    </>
  );
};

export default ProgressStudentGrowthTable;
